export default __webpack_public_path__ + "static/media/ag-icon.045de8d7.webp";